/* @flow */

import * as React from 'react';

import {Body} from 'shells/typography';

type Props = {|
    description: ?string,
    location: ?string,
|};

export function AccountCardContents(props: Props) {
    return (
        <div className='flex flex-dir-col gap-2'>
            {props.description && (
                <Body size='small' as='div' wrapAnywhere={true}>
                    {props.description}
                </Body>
            )}
            <Body size='small' as='div' color='placeholder' wrapAnywhere={true}>
                {props.location ? props.location : 'No location'}
            </Body>
        </div>
    );
}
